import { useEffect } from 'react'

export interface Props {
  capabilitiesToTestFor: [string, (isAble: boolean) => void][]
}

/**
 * Set up the capability we want to test for. This attaches an event
 * listener to the window (meaning: EVERYTHING!). Upon the first
 * interaction of that kind (like: a touch, or a mouse over, which, it
 * being the window, should happen pretty fast), it will call the appropriate
 */
function setupTest(
  eventToTestFor: string,
  actionHandler: (isAble: boolean) => void
) {
  window.addEventListener(
    eventToTestFor,
    function onFirstInteraction() {
      // The require interaction has happened, call the handler function
      actionHandler(true)

      // Remove Event listener from window, it has done it's work
      window.removeEventListener(eventToTestFor, onFirstInteraction, false)
    },
    false
  )
}

export const InteractionCapabilities = ({ capabilitiesToTestFor }: Props) => {
  useEffect(() => {
    capabilitiesToTestFor.forEach(test => {
      setupTest(...test)
    })
  }, [...capabilitiesToTestFor])

  return null
}
